import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';
import { a11y } from '~js/components/a11y';
import { LoadPhotoswipe } from '~js/components/load-photoswipe';

export class Zoom {
  constructor(container) {
    this.container = container;
    this.mediaContainer = this.container.querySelector(s.selectors$a.mediaContainer);
    this.slider = this.container.querySelector(s.selectors$a.productMediaSlider);
    this.zoomWrappers = this.container.querySelectorAll(s.selectors$a.zoomWrapper);
    this.zoomEnable = this.mediaContainer.dataset.gallery === 'true';
    this.a11y = a11y;

    if (this.zoomEnable) {
      this.init();
    }
  }

  init() {
    if (this.zoomWrappers.length) {
      this.zoomWrappers.forEach((element, i) => {
        element.addEventListener('click', (e) => {
          e.preventDefault();

          const isMoving = this.slider && this.slider.classList.contains(c.classes$9.isMoving);

          if (!isMoving) {
            this.a11y.state.trigger = element;
            this.createZoom(i);
          }
        });
      });
    }
  }

  createZoom(indexImage) {
    const instance = this;
    let items = [];
    let counter = 0;

    this.zoomWrappers.forEach((elementImage) => {
      const imgSrc = elementImage.getAttribute('href');
      const imgWidth = parseInt(elementImage.getAttribute(a.attributes$8.dataImageWidth));
      const imgHeight = parseInt(elementImage.getAttribute(a.attributes$8.dataImageHeight));

      items.push({
        src: imgSrc,
        w: imgWidth,
        h: imgHeight,
        msrc: imgSrc,
      });

      counter += 1;
      if (instance.zoomWrappers.length === counter) {
        let popupClass = `${c.classes$9.popupClass}`;

        if (counter === 1) {
          popupClass = `${c.classes$9.popupClass} ${c.classes$9.popupClassNoThumbs}`;
        }
        const options = {
          barsSize: { top: 60, bottom: 60 },
          history: false,
          focus: false,
          index: indexImage,
          mainClass: popupClass,
          showHideOpacity: true,
          showAnimationDuration: 250,
          hideAnimationDuration: 250,
          closeOnScroll: false,
          closeOnVerticalDrag: false,
          captionEl: false,
          closeEl: true,
          closeElClasses: ['caption-close'],
          tapToClose: false,
          clickToCloseNonZoomable: false,
          maxSpreadZoom: 2,
          loop: true,
          spacing: 0,
          allowPanToNext: true,
          pinchToClose: false,
        };

        new LoadPhotoswipe(items, options);
      }
    });
  }
}